const {
    accessToken = null,
    mapboxStyleUsername = null,
    mapboxStyleId = null,
} = window.MapboxConfig;
const mapboxgl = require('mapbox-gl');
const mapElement = document.getElementById('location-map');
const mapContent = mapElement.dataset.content ?? 'wells';
const contentTypes = {
    wells: {
        background: '#1D70B7',
        marker: '/dist/images/well-marker.png',
    },
    facilities: {
        background: '#71bf44',
        marker: '/dist/images/facility-marker.png',
    },
};

mapboxgl.accessToken = accessToken;

const initializeMap = () => {
    mapElement.hidden = false;

    const coordinates = JSON.parse(window.coordinates);
    const map = new mapboxgl.Map({
        container: mapElement,
        center: [coordinates.longitude, coordinates.latitude],
        zoom: 15,
        style: `mapbox://styles/${mapboxStyleUsername}/${mapboxStyleId}`,
        scrollZoom: false,
        dragRotate: false,
        touchPitch: false,
    });

    const geolocateControl = new mapboxgl.GeolocateControl({
        positionOptions: {
            enableHighAccuracy: true,
        },
        trackUserLocation: true,
        showUserHeading: true,
    });

    map.on('load', async () => {
        const geojson = {
            type: 'FeatureCollection',
            features: [
                {
                    type: 'Feature',
                    geometry: {
                        type: 'Point',
                        coordinates: [coordinates.longitude, coordinates.latitude],
                    },
                },
            ],
        };

        map.addControl(new mapboxgl.NavigationControl());

        map.addControl(geolocateControl);

        map.touchZoomRotate.disableRotation();

        map.addSource('location', {
            type: 'geojson',
            data: geojson,
        });

        map.loadImage(contentTypes[mapContent].marker, function (error, image) {
            if (error) {
                map.addLayer({
                    id: 'marker',
                    type: 'circle',
                    source: 'location',
                    filter: ['!', ['has', 'point_count']],
                    paint: {
                        'circle-color': contentTypes[mapContent].background,
                        'circle-radius': 8,
                        'circle-stroke-width': 1,
                        'circle-stroke-color': '#fff',
                    },
                });
                throw error;
            }

            map.addImage('custom-marker', image);
            map.addLayer({
                id: 'marker',
                type: 'symbol',
                source: 'location',
                filter: ['!', ['has', 'point_count']],
                layout: {
                    'icon-image': 'custom-marker',
                    'icon-size': 0.5,
                    'icon-anchor': 'bottom',
                },
            });
        });
    });
};

const initializeMapAfterConsent = () => {
    const consentManager = window.klaro.getManager();

    if (consentManager.getConsent('mapbox')) {
        initializeMap();
    }

    consentManager.watch({
        update(obj, name, data) {
            if (name !== 'applyConsents') return;
            if (!obj.states.mapbox) return;
            initializeMap();
        },
    });
};

initializeMapAfterConsent();
